import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

export const AdminCompaniesSkeleton: React.FC = () => {
  return (
    <div className="space-y-4 w-full relative z-10 animate-in fade-in duration-500">
      {/* Busca — grudada na description bar */}
      <div className="-mt-4 -mx-4 px-4 py-2 mb-4 bg-white/95 border-b border-purple-200">
        <div className="max-w-md">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={36}
            className="rounded-xl"
          />
        </div>
      </div>

      {/* Card "Parâmetros de Teste (Free Trial)" — tema claro */}
      <div className="bg-white rounded-2xl p-5 sm:p-6 shadow-xs border border-purple-200">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div className="space-y-2">
            <div className="flex items-center gap-2.5">
              <Skeleton
                variant="rectangular"
                width={36}
                height={36}
                className="rounded-xl"
              />
              <Skeleton variant="text" width={220} height={16} />
            </div>
            <Skeleton variant="text" width={320} height={10} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 grow max-w-3xl">
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width="100%"
                height={40}
                className="rounded-xl opacity-30"
              />
            ))}
          </div>
          <Skeleton
            variant="rectangular"
            width={140}
            height={40}
            className="rounded-xl opacity-40"
          />
        </div>
      </div>

      {/* Grid de cards de organização — header horizontal (avatar 48px ao
          lado do nome), não mais empilhado/centralizado. */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Card
            key={i}
            className="p-0 bg-white/80 border-purple-100 shadow-xl shadow-purple-500/5 rounded-3xl overflow-hidden"
          >
            <div className="relative p-4 sm:p-5 space-y-3">
              <div className="absolute top-4 right-4">
                <Skeleton
                  variant="rectangular"
                  width={60}
                  height={20}
                  className="rounded-full opacity-20"
                />
              </div>

              <div className="flex items-center gap-3 pr-20">
                <Skeleton
                  variant="rectangular"
                  width={48}
                  height={48}
                  className="rounded-xl opacity-40 shrink-0"
                />
                <div className="space-y-1.5 flex-1">
                  <Skeleton variant="text" width="70%" height={14} />
                  <Skeleton variant="text" width="50%" height={10} />
                </div>
              </div>

              <div className="flex gap-1.5">
                <Skeleton
                  variant="rectangular"
                  width={90}
                  height={22}
                  className="rounded-full opacity-20"
                />
                <Skeleton
                  variant="rectangular"
                  width={90}
                  height={22}
                  className="rounded-full opacity-20"
                />
              </div>

              <div className="flex items-center justify-between pt-1">
                <Skeleton variant="text" width={100} height={10} />
                <Skeleton
                  variant="rectangular"
                  width={50}
                  height={22}
                  className="rounded-full opacity-20"
                />
              </div>

              <div className="bg-gray-50/50 rounded-2xl p-3 grid grid-cols-3 gap-2">
                {[1, 2, 3].map((j) => (
                  <Skeleton
                    key={j}
                    variant="rectangular"
                    width="100%"
                    height={48}
                    className="rounded-xl opacity-10"
                  />
                ))}
              </div>

              <div className="bg-white rounded-2xl border border-purple-50 p-3 space-y-2">
                <Skeleton
                  variant="text"
                  width="40%"
                  height={10}
                  className="opacity-20"
                />
                <div className="grid grid-cols-3 gap-2">
                  {[1, 2, 3].map((j) => (
                    <Skeleton
                      key={j}
                      variant="rectangular"
                      width="100%"
                      height={36}
                      className="rounded-xl opacity-10"
                    />
                  ))}
                </div>
              </div>

              <div className="flex items-center justify-between pt-3 border-t border-purple-50">
                <div className="space-y-1">
                  <Skeleton
                    variant="text"
                    width={40}
                    height={8}
                    className="opacity-20"
                  />
                  <Skeleton
                    variant="text"
                    width={60}
                    height={10}
                    className="opacity-30"
                  />
                </div>
                <Skeleton
                  variant="rectangular"
                  width={36}
                  height={36}
                  className="rounded-xl opacity-20"
                />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminCompaniesSkeleton;
